

// products_info: [{
//     *              title:
//     *              description:
//     *              image: 
//     * }



import ville102 from "../../images/ville/102/banner.avif"
import ville200 from "../../images/ville/200/banner_1.avif"
import ville201 from "../../images/ville/201/banner_2_22.avif"
import ville202 from "../../images/ville/202/banner_1.avif"
import ville203 from "../../images/ville/203/banner_1.avif"

import design100 from "../../images/designs/nesta_design_100/gallery_1_1.avif"
import design101 from "../../images/designs/nesta_design_101/banner_main.avif"
import design102 from "../../images/designs/nesta_design_102/102.avif"
import design103 from "../../images/designs/nesta_design_103/103.avif"

export const ProductInformation = [
    {
        "image":ville200,
        "title": "Weimar",
        "description":"Nestaville Series 200 ",
        "path":"/ville/weimar"
    },
    {
        "image":ville201,
        "title": "Essence",
        "description":"Nestaville Series 203",
        "path":"/ville/essence"
    },
    {
        "image":ville202,
        "title": "Classica",
        "description":"Nestaville Series 201",
        "path":"/ville/classica"
    },
    {
        "image":ville203,
        "title": "Arcadia",
        "description":"Nestaville Series 202",
        "path":"/ville/arcadia"
    },
    {
        "image":ville102,
        "title": "Evoque",
        "description":"Nestaville Series 201",
        "path":"/ville/evoque"
    }
]

export const NestaDesignInformation = [
    {
        "image":design100,
        "title": "Florence",
        "description":"Nesta Design 100",
        "path":"/design/florence"
    },
    {
        "image":design101,
        "title": "Equinox",
        "description":"Nesta Design 101",
        "path":"/design/equinox"
    },
    {
        "image":design102,
        "title": "Serendi",
        "description":"Nesta Design 102",
        "path":"/design/serendi"
    },
    {
        "image":design103,
        "title": "Contour",
        "description":"Nesta Design 103",
        "path":"/design/contour"
    }
]


